import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import appSettings from 'apps/services/config';

import { AppController } from './app.controller';
import { AppService } from './app.service';
import { AssetAssignmentModule } from './asset-assignment/asset-assignment.module';
import { AssetAssignmentTransaction } from './asset-assignment/entity/asset-assignment-transaction.entity';
import { AssetAssignment } from './asset-assignment/entity/asset-assignment.entity';
import { AssetLocationMappingModule } from './asset-location-mapping/asset-location-mapping.module';
import { AssetLocationMapping } from './asset-location-mapping/entity/asset-location-mapping.entity';
import { AssetLocationTransaction } from './asset-location-mapping/entity/asset-location-transaction.entity';
import { AssetMaintainanceModule } from './asset-maintainance/asset-maintainance.module';
import { AssetMaintainanceTransactions } from './asset-maintainance/entity/asset-maintainance-transactions.entity';
import { AssetMaintainance } from './asset-maintainance/entity/asset-maintainance.entity';
import { AssetsActionControl } from './asset-tracking/asset-action-control.entity';
import { AssetsActionControlModule } from './asset-tracking/asset-action-control.module';
import { AssetsCatagory } from './assets-catagory/assets-catagory-entity';
import { AssetsCatagoryModule } from './assets-catagory/assets-catagory.module';
import { AssetsClassification } from './assets-classification/assets-classification-entity';
import { AssetsClassificationModule } from './assets-classification/assets-classification.module';
import { AssetsSubCatagory } from './assets-sub-catagory/assets-sub-catagory-entity';
import { AssetsSubCatagoryModule } from './assets-sub-catagory/assets-sub-catagory.module';
import { Location } from './locations/dto/loction-entity';
import { LocationModule } from './locations/locations.module';
import { Assets } from './open-assets/open-assets-entity';
import { AssetsModule } from './open-assets/open-assets.module';
import { AssetService } from './open-assets/asset-service.entity';
import { AssetServiceChecklist } from './open-assets/asset-service-checklist.entity';
import { AssetTransfer } from './asset-transfers/entity/asset-transfer.entity';
import { AssetLicense } from './asset-license/entity/asset-license.entity';
import { AssetLicenseModule } from './asset-license/asset-license.module';
import { AssetTransfersModule } from './asset-transfers/asset-transfers.module';
import { AssetRequistion } from './asset-requistion/entity/asset-requisition.entity';
import { AssetRequestModule } from './asset-requistion/asset-requistion.module';
import {  assetsLogTransactions } from './asset-license/entity/license-log.entity';
import { AssetTransaction } from './open-assets/asset-transaction-entity';
import { AssetsSale } from './asset-sale/entity/asset-sale.entity';
import { AssetsSaleModule } from './asset-sale/asset-sale.module';
import { LocationAudit } from './location-audit/entity/location-audit.entity';
import { LocationAuditModule } from './location-audit/location-audit.module';
import { ScheduleModule} from '@nestjs/schedule';
import { AssetCheckList } from './asset-check-list/dto/checklist.entity';
import { AssetChecklistModule } from './asset-check-list/checklist.module';


@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forRoot({
      type: 'mysql',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.assets_db,
      entities: [AssetsClassification, AssetsCatagory, AssetsSubCatagory, AssetsActionControl,AssetMaintainance,AssetMaintainanceTransactions,AssetLocationMapping,AssetLocationTransaction,AssetAssignment,AssetAssignmentTransaction,Assets,Location,AssetService,AssetServiceChecklist,AssetTransfer,AssetRequistion,AssetLicense,assetsLogTransactions,AssetTransaction,AssetsSale,LocationAudit,AssetCheckList],
      // synchronize: mastersConfigs.sync,
      synchronize: false,
      logging: false,
      // logger: new QueryLogger(new PinoLogger({ pinoHttp: { level: mastersConfigs.loggingMode } })),/
    }
    ), AssetsCatagoryModule, AssetsClassificationModule, AssetsSubCatagoryModule, AssetsActionControlModule,AssetMaintainanceModule,AssetLocationMappingModule,AssetAssignmentModule,AssetsModule,LocationModule,AssetTransfersModule,AssetRequestModule,AssetLicenseModule,AssetsSaleModule,LocationAuditModule,AssetChecklistModule],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule { }
